
import { Component, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { TestThresholdInfo } from '../../application/application.service';


@Component({
    selector: 'edittestthreshold-dialog-component',
    styleUrls: ['edittestthreshold.dialogcomponent.scss'],
    templateUrl: 'edittestthreshold.dialogcomponent.html',
})
export class EditTestThresholdDialogComponent {
    title: string;
    message: string;
    inputhint: string;
    oktext: string;
    canceltext: string;

    TestThresholdInfo?: TestThresholdInfo;
    ScoreCtrl = new FormControl(null, [Validators.required, Validators.pattern('^[0-9]+$')]);

    constructor(
        private dialogRef: MatDialogRef<EditTestThresholdDialogComponent>, 
        @Inject(MAT_DIALOG_DATA) data: _EditTestThresholdDialogOptions
    ) {
        this.title = data.TitleText || 'Input Requested';
        this.message = data.MessageText || '';
        this.oktext = data.OKText || 'OK';
        this.canceltext = data.CancelText || 'Cancel';
        
        this.TestThresholdInfo = data.TestThresholdInfo;
        if (data.TestThresholdInfo.Score) {
            this.ScoreCtrl.patchValue(data.TestThresholdInfo.Score);
        }
    }

    // #region Cancel Handler Method

    CancelHandler() {
        // User cancelled.
        this.dialogRef.close(null);
    }

    // #endregion

    // #region OK Handler Method

    OkHandler() {
        // Check if control is valid
        this.ScoreCtrl.markAsTouched();
        if (this.ScoreCtrl.invalid) return;

        this.dialogRef.close(this.ScoreCtrl.value);
    }

    // #endregion
}

// #region Custom Classes

export class _EditTestThresholdDialogOptions {
    TitleText?: string;
    MessageText?: string;
    OKText?: string;
    CancelText?: string;
    IconColor?: string;
    IconName?: string;
    ShowIcon?: boolean;
    height?: string;
    width?: string;
    
    TestThresholdInfo?: TestThresholdInfo;
}

// #endregion


// WEBPACK FOOTER //
// ./src/services/dialogs/edittestthreshold/edittestthreshold.dialogcomponent.ts